import MuiAvatar from './MuiAvatar';
import MuiButton from './MuiButton';
import MuiCard from './MuiCard';
import MuiCardActions from './MuiCardActions';
import MuiCardContent from './MuiCardContent';
import MuiCardHeader from './MuiCardHeader';
import MuiChip from './MuiChip';
import MuiDialogTitle from './MuiDialogTitle';
import MuiDialogContent from './MuiDialogContent';
import MuiDialogActions from './MuiDialogActions';
import MuiIconButton from './MuiIconButton';
import MuiInputBase from './MuiInputBase';
import MuiLinearProgress from './MuiLinearProgress';
import MuiListItem from './MuiListItem';
import MuiListItemIcon from './MuiListItemIcon';
import MuiMenu from './MuiMenu';
import MuiOutlinedInput from './MuiOutlinedInput';
import MuiPaper from './MuiPaper';
import MuiSelect from './MuiSelect';
import MuiTable from './MuiTable';
import MuiTableHead from './MuiTableHead';
import MuiTableCell from './MuiTableCell';
import MuiTablePagination from './MuiTablePagination';
import MuiTableRow from './MuiTableRow';
import MuiToggleButton from './MuiToggleButton';
import MuiTypography from './MuiTypography';
import MuiTabs from './MuiTabs';
import MuiTab from './MuiTab';
import MuiDialog from './MuiDialog';
import MuiGridList from './MuiGridList';
import MuiGridListTile from './MuiGridListTile';
import MuiGridListTileBar from './MuiGridListTileBar';
import MuiCircularProgress from './MuiCircularProgress';
import MuiPopover from './MuiPopover';
import MuiMenuItem from './MuiMenuItem';
import MuiSwitch from './MuiSwitch';
import MuiList from './MuiList';
import MuiAutocomplete from './MuiAutocomplete'
import MuiPickersBasePicker from './MuiPickersBasePicker'
import MuiPickersCalendarHeader from './MuiPickersCalendarHeader'
import MuiPickersCalendar from './MuiPickersCalendar'
import MuiPickersDay from './MuiPickersDay'

const params = {
  MuiAutocomplete,
  MuiAvatar,
  MuiButton,
  MuiCard,
  MuiCardActions,
  MuiCardContent,
  MuiCardHeader,
  MuiChip,
  MuiDialogTitle,
  MuiDialogContent,
  MuiDialogActions,
  MuiIconButton,
  MuiInputBase,
  MuiMenu,
  MuiLinearProgress,
  MuiListItem,
  MuiListItemIcon,
  MuiOutlinedInput,
  MuiPaper,
  MuiSelect,
  MuiTable,
  MuiTableHead,
  MuiTableCell,
  MuiTablePagination,
  MuiTableRow,
  MuiToggleButton,
  MuiTypography,
  MuiTabs,
  MuiTab,
  MuiDialog,
  MuiGridListTile,
  MuiGridListTileBar,
  MuiGridList,
  MuiPopover,
  MuiCircularProgress,
  MuiMenuItem,
  MuiSwitch,
  MuiList,
  MuiPickersBasePicker,
  MuiPickersCalendarHeader,
  MuiPickersCalendar,
  MuiPickersDay
}

export default params
